import { render, staticRenderFns } from "./PizarraContent.vue?vue&type=template&id=ed7f18f0&scoped=true&"
import script from "./PizarraContent.vue?vue&type=script&lang=js&"
export * from "./PizarraContent.vue?vue&type=script&lang=js&"
import style0 from "./PizarraContent.vue?vue&type=style&index=0&id=ed7f18f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed7f18f0",
  null
  
)

export default component.exports